<template>
  <v-speed-dial
    v-model="fab"
    :open-on-hover="!small"
    :fixed="!absolute"
    :absolute="absolute"
    left
    bottom
    class="qualification"
    :class="{ animation: !fab }"
  >
    <template v-slot:activator>
      <v-card class="half-radius pa-2" :class="{ border: !small }">
        <span v-if="!small" class="mr-2 title custom-text">Assessment Pending</span>
        <v-btn v-model="fab" color="#29284c" dark fab :x-small="!small">
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-fountain-pen</v-icon>
        </v-btn>
      </v-card>
    </template>
    <app-base
      :qualification="qualification"
      @close="fab = false"
      @new-qual="$emit('new-qual', $event)"
    />
  </v-speed-dial>
</template>
<script>
import Base from "./QuaBase.vue";
export default {
  components: {
    appBase: Base,
  },
  props: {
    qualification: {
      required: true,
    },
    absolute: Boolean,
  },
  data() {
    return {
      fab: false,
    };
  },
  computed: {
    small() {
      return this.$vuetify.breakpoint.xs;
    },
  },
};
</script>
<style scoped>
.border {
  border: 2px dashed #29284c;
}
.animation {
  animation: blink 0.5s infinite ease-in-out;
}
@keyframes blink {
  0% {
    transform: translate(2px);
  }
  20% {
    transform: translate(-2px);
  }
  40% {
    transform: translate(2px);
  }
  60% {
    transform: translate(-2px);
  }
  100% {
    transform: translate(2px);
  }
}
</style>
